export default function serviceWorkerRegistration(config) {
  const swUrl = `${process.env.REACT_APP_PUBLIC_URL}/service-worker.js`;

  if ("serviceWorker" in navigator) {
    navigator.serviceWorker.register(swUrl).then((registration) => {
      
      // Force SW check on load
      registration.update();

      registration.onupdatefound = () => {
        const installingWorker = registration.installing;
        if (!installingWorker) return;

        installingWorker.onstatechange = () => {
          if (installingWorker.state === "installed") {
            if (navigator.serviceWorker.controller) {
              // New update available → SW in waiting state
              console.log("New version available.");

              // Auto-activate the new SW
              if (registration.waiting) {
                registration.waiting.postMessage({ action: "skipWaiting" });
              }

              // Reload when the new SW takes control
              navigator.serviceWorker.oncontrollerchange = () => {
                console.log("New version activated. Reloading...");
                window.location.reload();
              };

              if (config?.onUpdate) config.onUpdate(registration);
            } else {
              // First install
              if (config?.onSuccess) config.onSuccess(registration);
            }
          }
        };
      };
    }).catch((error) => {
      console.error("SW registration failed:", error);
    });
  }
}

export function unregister() {
  if ("serviceWorker" in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => registration.unregister())
      .catch((error) => console.error(error.message));
  }
}
